import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/src/components/ui/select";
import { useEmit } from "@/src/lib/actions";
import { SortByCustomersOptions, SortByOperatorsOptions } from "./state";
import { useState } from "react";
import { PayerType } from "./model";

const OrderBySelect = ({ payerType }: { payerType: PayerType }) => {
  const [value, setValue] = useState(
    payerType === PayerType.CUSTOMER ? SortByCustomersOptions.BOOKING_DATE : SortByOperatorsOptions.BOOKING_DATE,
  );

  console.log("payerType:", payerType);

  const emitSortByCustomers = useEmit<SortByCustomersOptions>("payments-customers:sortBy");
  const emitSortByOperators = useEmit<SortByOperatorsOptions>("payments-operators:sortBy");

  const onValueChange = (value: SortByCustomersOptions | SortByOperatorsOptions) => {
    setValue(value);
    if (payerType === PayerType.CUSTOMER) {
      emitSortByCustomers(value as SortByCustomersOptions);
    } else {
      emitSortByOperators(value as SortByOperatorsOptions);
    }
  };

  return (
    <div className="w-60">
      <Select onValueChange={onValueChange} value={value}>
        <SelectTrigger>
          <SelectValue placeholder="Sort by" />
        </SelectTrigger>
        <SelectContent>
          {payerType === PayerType.CUSTOMER ? (
            <>
              <SelectItem value={SortByCustomersOptions.BOOKING_DATE}>Sort by: Booking date</SelectItem>
              <SelectItem value={SortByCustomersOptions.PAYMENT_STATUS}>Sort by: Payment status</SelectItem>
              <SelectItem value={SortByCustomersOptions.SUPPLIER}>Sort by: Supplier</SelectItem>
            </>
          ) : (
            <>
              <SelectItem value={SortByOperatorsOptions.BOOKING_DATE}>Sort by: Booking date</SelectItem>
              <SelectItem value={SortByOperatorsOptions.DUE_DATE}>Sort by: Due date</SelectItem>
              <SelectItem value={SortByOperatorsOptions.NEW_BOOKINGS}>Sort by: New bookings</SelectItem>
              <SelectItem value={SortByOperatorsOptions.PAYMENT_STATUS}>Sort by: Payment status</SelectItem>
              <SelectItem value={SortByOperatorsOptions.SUPPLIER}>Sort by: Supplier</SelectItem>
            </>
          )}
        </SelectContent>
      </Select>
    </div>
  );
};

export default OrderBySelect;
